import React from "react";
import sohbetler1Large from '../../../assets/books/kapaklar/sohbetler_1_600.jpg';
import sohbetler1Mini from '../../../assets/books/kapaklar/sohbetler_1-300.jpg';
export const Sohbetler1Description = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img src={sohbetler1Large} 
                alt="Aşka Meşke Semaya Yolculuk" 
                srcSet={`${sohbetler1Mini} 300w, ${sohbetler1Large} 600w`}
                sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                İslâm’da çevre ahlâkının temeli, yaptığımız her şeyden sorumlu olduğumuza inanmak ve bu inancın oluşturduğu bilinçle hareket etmektir.
                O zaman, gerekmedikçe bir yaprağı bile koparamazsınız.
            </p>
            <p>
                Kedinizi ve köpeğinizi aç bırakamazsınız. Asla bir hayvana eziyet edemezsiniz.
                İçtiğiniz meyve suyunun kutusunu veya yediğiniz çikolatanın ambalajını arabanızın camından rastgele atamazsınız.
                Fabrikanızın atıklarını filtrelemeden kontrolsüz olarak deniz, göl ve nehirlere boşaltamazsınız.
                Sorumluluk bilinci ve davranışlarımızla Allah’a teslim olmak bunu gerektirir.
            </p>
            <p>
                Çevre bilinci, güzel ahlâk sahibi insanlara mahsustur. Hakikaten o kadar insanın tahmininizden daha fazla çevre bilincine ihtiyacı var.
            </p>
        </div>
    )
}
export const Sohbetler1SummaryDescription = (props: any) => {
    return (
        <p>
            İslâm’da çevre ahlâkının temeli, yaptığımız her şeyden sorumlu olduğumuza inanmak ve bu inancın oluşturduğu bilinçle hareket etmektir.
            O zaman, gerekmedikçe bir yaprağı bile koparamazsınız.
            Kedinizi ve köpeğinizi aç bırakamazsınız. Asla bir hayvana eziyet edemezsiniz.
            İçtiğiniz meyve suyunun kutusunu veya yediğiniz çikolatanın ambalajını arabanızın camından rastgele atamazsınız.
            Fabrikanızın atıklarını filtrelemeden kontrolsüz olarak deniz, göl ve nehirlere boşaltamazsınız.
            Sorumluluk bilinci ve davranışlarımızla Allah’a teslim olmak bunu gerektirir.
        </p>
    )
}